<div class="container">
  <fgb-partner-offers-list></fgb-partner-offers-list>
</div>
